import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './helpers/installAxiosHeaderSecurity';

/* eslint-disable import/no-unresolved */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { Provider } from 'react-redux';
import { GlobalStyle } from 'styles/global';
import { ThemeProvider, theme } from 'styles/themes';

import { ModalContextProvider } from 'context/ModalContext';
import LanguageProvider from 'vendys/translations/LanguageProvider';
import { datadogLogsInit } from 'helpers/logsUtils';

import store, { gaId } from './helpers/loggers';
import App from './containers/App';
import 'styles/themes/antd.less';
// alias 'styles' 는 vendys-commons/styles 라 여기선 '@' 를 쓴다
import '@/styles/main.css';

datadogLogsInit();

const rootElement = document.getElementById('root');
const customContext = React.createContext(null);

ReactGA.initialize([{ trackingId: gaId.DMP_TRACKING_ID }, { trackingId: gaId.MARKETING_TRACKING_ID }]);

const render = () => {
  ReactDOM.render(
    <Provider store={store} className="compnay-manager" context={customContext}>
      <LanguageProvider>
        <ThemeProvider theme={theme.default}>
          <ModalContextProvider>
            <GlobalStyle />
            <Router>
              <App store={store} />
            </Router>
          </ModalContextProvider>
        </ThemeProvider>
      </LanguageProvider>
    </Provider>,
    rootElement
  );
};
render();
